// Fonte UNICA degli stati cantiere — allineata al backend `Cantiere.STATI`
// (backend/apps/cantieri/models.py). Import obbligatorio sia dalla lista
// (Cantieri.jsx → badge + filtri) sia dal dettaglio (StatoTab.jsx → chip),
// così label e colore non possono più divergere (DBT-050).
//
// `color` usa i token semantici del design system: la lista li rende come
// badge (color-mix), il dettaglio come chip. Stesso stato = stesso colore
// ovunque.

export const CANTIERE_STATI = [
  { value: 'nuovo',       label: 'Nuovo',       color: 'var(--zone-blue)' },
  { value: 'sopralluogo', label: 'Sopralluogo', color: 'var(--warn)' },
  { value: 'in_corso',    label: 'In corso',    color: 'var(--ok)' },
  { value: 'sospeso',     label: 'Sospeso',     color: 'var(--ds-danger)' },
  { value: 'completato',  label: 'Completato',  color: 'var(--zone-violet)' },
  { value: 'annullato',   label: 'Annullato',   color: 'var(--ds-muted)' },
];

// { value: { label, color } } — usato dal badge lista e da lookup rapidi.
export const STATO_META = Object.fromEntries(
  CANTIERE_STATI.map((s) => [s.value, { label: s.label, color: s.color }])
);

// Elenco ordinato dei soli valori — usato dai select filtro.
export const STATI_LIST = CANTIERE_STATI.map((s) => s.value);

// ── Criteri DERIVATI (non sono campi `stato`) ────────────────────────────────
// NB architetturale: `?stato=` filtra un CAMPO (uno dei valori di CANTIERE_STATI);
// `?vista=` nomina un CRITERIO DERIVATO (aggregato o calcolato). Sono due cose
// diverse: NON vanno mischiate in futuro (es. non aggiungere 'attivi'/'ritardo'
// a CANTIERE_STATI). Home e Cantieri condividono queste definizioni da qui, così
// il conteggio KPI, il filtro vista e l'icona di riga non possono divergere.

// Stati considerati "attivi" (lavori in avvio o in corso) — vista ?vista=attivi.
export const STATI_ATTIVI = ['nuovo', 'sopralluogo', 'in_corso'];

// Stati che escludono il "ritardo" (cantiere chiuso o fermo).
const STATI_NON_RITARDO = ['completato', 'annullato', 'sospeso'];

// Criterio "in ritardo": data fine stimata passata & stato non chiuso — vista
// ?vista=ritardo, e icona di riga (allineato a Home KPI). `today` = 'YYYY-MM-DD'.
export function isCantiereInRitardo(c, today) {
  let oggi = today;
  if (!oggi) {
    const d = new Date();
    oggi = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }
  return !!c.data_fine_stimata && c.data_fine_stimata < oggi && !STATI_NON_RITARDO.includes(c.stato);
}
